import PeriprocedureelBeleidRivaroxaban from "../../../../src/client/lta-antistolling/periprocedureel-beleid-rivaroxaban.json";
import ChartCollapse from "../../../../src/components/interactions/basic-collapse/Chart.js";
import * as React from 'react';
export default {
  PeriprocedureelBeleidRivaroxaban,
  ChartCollapse,
  React
};